import {
    buildControlSpecViewModel,
    mergeControlSpecFindings,
    buildControlSpecFindingsMeta,
    buildEmptyControlSpecFindingsMessage,
    buildControlSpecFindingRowModel,
    localizeControlSpecFindingMessage,
    buildControlSpecOutputSections,
    buildControlSpecValveModelRowModel,
    buildControlSpecIoRowModel,
    buildControlSpecErrorStepRowModel,
    buildControlSpecTimeoutFindingRowModel,
    buildControlSpecConditionRowModel,
    buildControlSpecActionRowModel,
    formatIoReferencedBy,
    formatControlSpecCommands,
    formatControlSpecConditions,
    formatControlSpecConditionStepExpression,
    formatControlSpecConditionBranches,
    buildSignalCategoryOptionsState,
    buildControlSpecSignalCategoryListState,
    buildControlSpecSignalCategoryRowModel,
    buildLoadedSignalCategoryFormState,
    buildResetSignalCategoryFormState,
    buildControlSpecSignalCategoryFormInput,
    buildControlSpecSignalCategoryDraft,
    validateControlSpecSignalCategoryDraft,
    buildSavedControlSpecSignalCategories,
    buildDeleteControlSpecSignalCategoryState,
    buildControlSpecSignalListState,
    buildControlSpecSignalRowModel,
    buildLoadedControlSpecSignalFormState,
    buildResetControlSpecSignalFormState,
    buildControlSpecSignalFormInput,
    buildControlSpecSignalDraft,
    validateControlSpecSignalDraft,
    buildSavedControlSpecSignals,
    findControlSpecSignalReferenceInActuators,
    buildDeleteControlSpecSignalState,
    buildControlSpecFlowSignalCandidateOptionsState,
    buildControlSpecFlowSignalCandidateApplyState,
    buildControlSpecActuatorListState,
    buildControlSpecActuatorRowModel,
    buildLoadedControlSpecActuatorFormState,
    buildResetControlSpecActuatorFormState,
    buildControlSpecActionSignalOptionsState,
    buildControlSpecActionListState,
    buildControlSpecActionListRowModel,
    buildLoadedControlSpecActionDetailState,
    buildDeleteControlSpecActionState,
    buildControlSpecActionCompletionModeFieldState,
    buildControlSpecActionDetailFormInput,
    buildControlSpecActionDetailDraft,
    validateControlSpecActionDetailDraft,
    buildSavedControlSpecActionDetailState,
    buildResetControlSpecActuatorActionState,
    buildAddedControlSpecActionState,
    buildControlSpecActuatorFormInput,
    buildControlSpecActuatorDraft,
    validateControlSpecActuatorDraft,
    buildSavedControlSpecActuators,
    buildDeleteControlSpecActuatorState
} from "../frontend/control-spec-helper.js";

function getHelper(helper) {
    return helper || null;
}

function applyActuatorValveModelFormState(doc = document, valveModel = null) {
    const source = valveModel && typeof valveModel === "object" ? valveModel : {};
    const stateTable = source?.stateTable && typeof source.stateTable === "object" ? source.stateTable : {};
    const assign = (id, value) => {
        const field = doc.getElementById(id);
        if (field) field.value = String(value || "");
    };

    assign("inputActuatorValvePositiveOutput", source.positiveOutput);
    assign("inputActuatorValveNegativeOutput", source.negativeOutput);
    assign("inputActuatorValveSingleOutput", source.singleOutput);
    assign("selectActuatorValveSingleActiveDirection", source.singleSolenoidActiveDirection || "positive");
    assign("selectActuatorValveStateExtendPositive", stateTable?.extend?.positive || "");
    assign("selectActuatorValveStateExtendNegative", stateTable?.extend?.negative || "");
    assign("selectActuatorValveStateExtendSingle", stateTable?.extend?.single || "");
    assign("selectActuatorValveStateRetractPositive", stateTable?.retract?.positive || "");
    assign("selectActuatorValveStateRetractNegative", stateTable?.retract?.negative || "");
    assign("selectActuatorValveStateRetractSingle", stateTable?.retract?.single || "");
    assign("selectActuatorValveStateStopPositive", stateTable?.stop?.positive || "");
    assign("selectActuatorValveStateStopNegative", stateTable?.stop?.negative || "");
    assign("selectActuatorValveStateStopSingle", stateTable?.stop?.single || "");
    assign("selectActuatorValveStateEmergencyPositive", stateTable?.emergency?.positive || "");
    assign("selectActuatorValveStateEmergencyNegative", stateTable?.emergency?.negative || "");
    assign("selectActuatorValveStateEmergencySingle", stateTable?.emergency?.single || "");
}

const defaultActuatorHelper = {
    buildControlSpecActuatorListState,
    buildControlSpecActuatorRowModel,
    buildLoadedControlSpecActuatorFormState,
    buildResetControlSpecActuatorFormState,
    buildControlSpecActionSignalOptionsState,
    buildControlSpecActionListState,
    buildControlSpecActionListRowModel,
    buildLoadedControlSpecActionDetailState,
    buildDeleteControlSpecActionState,
    buildControlSpecActionCompletionModeFieldState,
    buildControlSpecActionDetailFormInput,
    buildControlSpecActionDetailDraft,
    validateControlSpecActionDetailDraft,
    buildSavedControlSpecActionDetailState,
    buildResetControlSpecActuatorActionState,
    buildAddedControlSpecActionState,
    buildControlSpecActuatorFormInput,
    buildControlSpecActuatorDraft,
    validateControlSpecActuatorDraft,
    buildSavedControlSpecActuators,
    buildDeleteControlSpecActuatorState
};

const defaultSignalHelper = {
    buildSignalCategoryOptionsState,
    buildControlSpecSignalCategoryListState,
    buildControlSpecSignalCategoryRowModel,
    buildLoadedSignalCategoryFormState,
    buildResetSignalCategoryFormState,
    buildControlSpecSignalCategoryFormInput,
    buildControlSpecSignalCategoryDraft,
    validateControlSpecSignalCategoryDraft,
    buildSavedControlSpecSignalCategories,
    buildDeleteControlSpecSignalCategoryState,
    buildControlSpecSignalListState,
    buildControlSpecSignalRowModel,
    buildLoadedControlSpecSignalFormState,
    buildResetControlSpecSignalFormState,
    buildControlSpecSignalFormInput,
    buildControlSpecSignalDraft,
    validateControlSpecSignalDraft,
    buildSavedControlSpecSignals,
    findControlSpecSignalReferenceInActuators,
    buildDeleteControlSpecSignalState,
    buildControlSpecFlowSignalCandidateOptionsState,
    buildControlSpecFlowSignalCandidateApplyState
};

const defaultViewHelper = {
    buildControlSpecViewModel,
    mergeControlSpecFindings,
    buildControlSpecFindingsMeta,
    buildEmptyControlSpecFindingsMessage,
    buildControlSpecFindingRowModel,
    localizeControlSpecFindingMessage,
    buildControlSpecOutputSections,
    buildControlSpecValveModelRowModel,
    buildControlSpecIoRowModel,
    buildControlSpecErrorStepRowModel,
    buildControlSpecTimeoutFindingRowModel,
    buildControlSpecConditionRowModel,
    buildControlSpecActionRowModel,
    formatIoReferencedBy,
    formatControlSpecCommands,
    formatControlSpecConditions,
    formatControlSpecConditionStepExpression,
    formatControlSpecConditionBranches
};

export function getCurrentControlSpecViewModel({ project, generationIr, helper }) {
    const resolvedHelper = getHelper(helper) || defaultViewHelper;
    if (!resolvedHelper || typeof resolvedHelper.buildControlSpecViewModel !== "function") {
        return null;
    }
    return resolvedHelper.buildControlSpecViewModel(project, generationIr);
}

export function buildControlSpecValidationPayload(deps = {}) {
    const {
        getPreferredGenerationApi = () => null,
        getActivePlcProfile = () => ({}),
        state = { chat: {} }
    } = deps;
    const generationApi = typeof getPreferredGenerationApi === "function" ? getPreferredGenerationApi() : null;
    if (!generationApi) return null;
    const flowContext = typeof generationApi.getFlowContext === "function" ? generationApi.getFlowContext() : null;
    const generationIr = typeof generationApi.getGenerationIr === "function" ? generationApi.getGenerationIr() : null;
    if (!flowContext && !generationIr) return null;
    const activeProfile = typeof getActivePlcProfile === "function" ? getActivePlcProfile() : {};
    return {
        flowContext,
        generationIr,
        vendor: activeProfile.vendorTarget || state?.chat?.dialect,
        plcProfileId: activeProfile.id,
        plcProfile: activeProfile,
        mode: "validate"
    };
}

export function buildControlSpecValidationRequestKey(payload) {
    try {
        return JSON.stringify(payload || {});
    } catch {
        return "";
    }
}

export function getCombinedControlSpecFindings(vm, validationState, helper) {
    const resolvedHelper = getHelper(helper) || defaultViewHelper;
    if (!resolvedHelper || typeof resolvedHelper.mergeControlSpecFindings !== "function") {
        return [];
    }
    return resolvedHelper.mergeControlSpecFindings(vm?.findings, validationState?.findings);
}

export function renderControlSpecView(deps = {}) {
    const {
        project,
        helper = defaultViewHelper,
        getGenerationIr = () => null,
        ensureSignalCategories = () => {},
        renderSignalCategories = () => {},
        getSelectedSignalCategoryId = () => "",
        renderSignalCategoryOptions = () => {},
        renderSignals = () => {},
        renderFlowSignalCandidates = () => {},
        renderOutputs = () => {},
        renderFindings = () => {},
        activeView = "",
        skipValidationRefresh = false,
        immediateValidation = false,
        scheduleValidationRefresh = () => {}
    } = deps;

    ensureSignalCategories();
    renderSignalCategories();
    renderSignalCategoryOptions(getSelectedSignalCategoryId());
    renderSignals();

    const vm = getCurrentControlSpecViewModel({
        project,
        generationIr: getGenerationIr(),
        helper
    });
    if (!vm) return null;

    renderFlowSignalCandidates();
    renderOutputs(vm);
    renderFindings(vm);
    if (activeView === "control-spec" && !skipValidationRefresh) {
        scheduleValidationRefresh({ immediate: Boolean(immediateValidation) });
    }
    return vm;
}

export function scheduleControlSpecServerValidationRefresh(deps = {}) {
    const {
        apiGenerationClient,
        validationState,
        clearTimer = (timerId) => clearTimeout(timerId),
        setTimer = (callback, delay) => setTimeout(callback, delay),
        refreshControlSpecServerValidation = async () => {},
        logWarning = () => {},
        options = {}
    } = deps;
    if (!apiGenerationClient || typeof apiGenerationClient.postValidate !== "function") return { scheduled: false };
    if (validationState.timerId) {
        clearTimer(validationState.timerId);
        validationState.timerId = 0;
    }
    const delay = options.immediate ? 0 : 120;
    validationState.timerId = setTimer(() => {
        validationState.timerId = 0;
        refreshControlSpecServerValidation(options).catch((error) => {
            logWarning("[control-spec] /api/validate refresh failed:", error);
        });
    }, delay);
    return { scheduled: true, delay };
}

export async function refreshControlSpecServerValidation(deps = {}) {
    const {
        apiGenerationClient,
        validationState,
        buildControlSpecValidationPayload: buildPayload = () => null,
        buildControlSpecValidationRequestKey: buildRequestKey = () => "",
        options = {},
        getNowIsoString = () => new Date().toISOString(),
        notifyAssistantUiChanged = () => {},
        activeView = "",
        renderControlSpecView = () => {}
    } = deps;
    if (!apiGenerationClient || typeof apiGenerationClient.postValidate !== "function") {
        validationState.findings = [];
        validationState.errorMessage = "";
        validationState.busy = false;
        return { ok: false, skipped: "no-client" };
    }

    const payload = buildPayload();
    if (!payload) {
        validationState.findings = [];
        validationState.errorMessage = "";
        validationState.busy = false;
        return { ok: false, skipped: "no-payload" };
    }

    const requestKey = buildRequestKey(payload);
    if (!options.force && requestKey && requestKey === validationState.lastAppliedKey) {
        return { ok: false, skipped: "unchanged" };
    }
    if (validationState.busy && requestKey === validationState.lastRequestedKey) {
        return { ok: false, skipped: "busy-same-request" };
    }

    validationState.busy = true;
    validationState.errorMessage = "";
    validationState.lastRequestedKey = requestKey;
    const requestSeq = ++validationState.requestSeq;

    let accessToken = null;
    if (typeof apiGenerationClient.getAccessToken === "function") {
        try {
            accessToken = await apiGenerationClient.getAccessToken();
        } catch {
            accessToken = null;
        }
    }

    try {
        const result = await apiGenerationClient.postValidate(payload, { accessToken });
        if (requestSeq !== validationState.requestSeq) return { ok: false, skipped: "stale-success" };
        validationState.findings = Array.isArray(result?.validationFindings) ? result.validationFindings : [];
        validationState.errorMessage = "";
        validationState.lastValidatedAt = getNowIsoString();
        validationState.lastAppliedKey = requestKey;
        notifyAssistantUiChanged();
        return { ok: true, findings: validationState.findings };
    } catch (error) {
        if (requestSeq !== validationState.requestSeq) return { ok: false, skipped: "stale-error" };
        validationState.findings = [];
        validationState.errorMessage = error?.message || "validate_failed";
        notifyAssistantUiChanged();
        return { ok: false, errorMessage: validationState.errorMessage };
    } finally {
        if (requestSeq === validationState.requestSeq) {
            validationState.busy = false;
            if (activeView === "control-spec") {
                renderControlSpecView({ skipValidationRefresh: true });
            }
            notifyAssistantUiChanged();
        }
    }
}

function renderEmptyRow(tbody, colspan, message, escapeHtml) {
    tbody.innerHTML = `
            <tr>
                <td colspan="${colspan}" class="ctrl-spec-empty-cell">
                    ${escapeHtml(message)}
                </td>
            </tr>
        `;
}

function buildFindingTargetActionsHtml(actions = [], escapeHtml = (value) => String(value ?? "")) {
    const buttons = (Array.isArray(actions) ? actions : []).map((action) => {
        const attrs = [`data-finding-target="${escapeHtml(action?.target)}"`];
        Object.entries(action?.dataset || {}).forEach(([key, value]) => {
            const attrName = `data-${String(key).replace(/[A-Z]/g, (ch) => `-${ch.toLowerCase()}`)}`;
            attrs.push(`${attrName}="${escapeHtml(value)}"`);
        });
        return `<button type="button" class="control-spec-action-btn" ${attrs.join(" ")}>${escapeHtml(action?.label)}</button>`;
    });
    return buttons.length ? `<div class="ctrl-action-target-btns">${buttons.join("")}</div>` : "";
}

export function renderControlSpecFindings(doc = document, deps = {}) {
    const {
        vm,
        helper = defaultViewHelper,
        validationState = {},
        escapeHtml = (value) => String(value ?? ""),
        buildFindingTargetActions = null
    } = deps;
    const tbody = doc.getElementById("controlSpecFindingsTableBody");
    const meta = doc.getElementById("controlSpecFindingsMeta");
    if (!tbody) return;

    const resolvedHelper = getHelper(helper);
    const renderFindingTargetActions =
        typeof buildFindingTargetActions === "function"
            ? buildFindingTargetActions
            : (actions) => buildFindingTargetActionsHtml(actions, escapeHtml);
    const findings = getCombinedControlSpecFindings(vm, validationState, resolvedHelper);
    const findingsMeta = resolvedHelper.buildControlSpecFindingsMeta(findings, validationState);
    if (meta) meta.textContent = findingsMeta.text;

    if (!findings.length) {
        const emptyMessage = resolvedHelper.buildEmptyControlSpecFindingsMessage(validationState);
        renderEmptyRow(tbody, 4, emptyMessage, escapeHtml);
        return;
    }

    tbody.innerHTML = "";
    findings.forEach((finding) => {
        const tr = doc.createElement("tr");
        tr.className = "ctrl-spec-tr";
        const display = resolvedHelper.buildControlSpecFindingRowModel(
            finding,
            resolvedHelper.localizeControlSpecFindingMessage
        );
        tr.innerHTML = `
            <td style="padding: 10px 8px; font-weight: bold; color: ${display.severityColor};">${escapeHtml(display.severity)}</td>
            <td class="ctrl-spec-td-mono-bold">${escapeHtml(display.code)}</td>
            <td class="ctrl-spec-td-desc-520">${escapeHtml(display.message)}</td>
            <td class="ctrl-spec-td-muted">
                <div class="ctrl-source-label">source: ${escapeHtml(display.sourceText)}</div>
                <div>${escapeHtml(display.targetText)}</div>
                ${renderFindingTargetActions(display.actions)}
            </td>
        `;
        tbody.appendChild(tr);
    });
}

export function renderControlSpecOutputs(doc = document, deps = {}) {
    const {
        vm,
        helper = defaultViewHelper,
        escapeHtml = (value) => String(value ?? ""),
        formatIoReferencedBy = defaultViewHelper.formatIoReferencedBy,
        formatCommands = defaultViewHelper.formatControlSpecCommands,
        formatConditions = defaultViewHelper.formatControlSpecConditions,
        formatConditionStepExpression = defaultViewHelper.formatControlSpecConditionStepExpression,
        formatConditionBranches = defaultViewHelper.formatControlSpecConditionBranches
    } = deps;
    const tbody = doc.getElementById("controlSpecIoTableBody");
    const meta = doc.getElementById("controlSpecIoTableMeta");
    const valveModelBody = doc.getElementById("controlSpecValveModelBody");
    const valveModelMeta = doc.getElementById("controlSpecValveModelMeta");
    const actionBody = doc.getElementById("controlSpecActionStepsBody");
    const actionMeta = doc.getElementById("controlSpecActionStepsMeta");
    const conditionBody = doc.getElementById("controlSpecConditionStepsBody");
    const conditionMeta = doc.getElementById("controlSpecConditionStepsMeta");
    const errorBody = doc.getElementById("controlSpecErrorListBody");
    const errorMeta = doc.getElementById("controlSpecErrorListMeta");
    if (!tbody) return;

    const resolvedHelper = getHelper(helper);
    const sections = resolvedHelper.buildControlSpecOutputSections(vm);
    if (meta) meta.textContent = sections.io.metaText;
    renderControlSpecValveModels(doc, sections.valveModel, valveModelBody, valveModelMeta, {
        helper: resolvedHelper,
        escapeHtml
    });
    renderControlSpecActionSteps(doc, sections.action, actionBody, actionMeta, {
        helper: resolvedHelper,
        escapeHtml,
        formatCommands,
        formatConditions
    });
    renderControlSpecConditionSteps(doc, sections.condition, conditionBody, conditionMeta, {
        helper: resolvedHelper,
        escapeHtml,
        formatConditionStepExpression,
        formatConditionBranches
    });
    renderControlSpecErrorList(doc, sections.error, errorBody, errorMeta, {
        helper: resolvedHelper,
        escapeHtml
    });

    if (!sections.io.count) {
        renderEmptyRow(tbody, 6, sections.io.emptyMessage, escapeHtml);
        return;
    }

    tbody.innerHTML = "";
    sections.io.rows.forEach((entry) => {
        const tr = doc.createElement("tr");
        tr.className = "ctrl-spec-tr";
        const row = resolvedHelper.buildControlSpecIoRowModel(entry, formatIoReferencedBy);
        tr.innerHTML = `
            <td class="ctrl-spec-td"><span class="control-spec-badge ${row.badgeClass}">${escapeHtml(row.direction)}</span></td>
            <td class="ctrl-spec-td-mono-bold-muted">${escapeHtml(row.address)}</td>
            <td class="ctrl-spec-td-mono-id">${escapeHtml(row.signalId)}</td>
            <td class="ctrl-spec-td">${escapeHtml(row.signalName)}</td>
            <td class="ctrl-spec-td-muted">${escapeHtml(row.usagesText)}</td>
            <td class="ctrl-spec-td-desc-320">${escapeHtml(row.refsText)}</td>
        `;
        tbody.appendChild(tr);
    });
}

export function renderControlSpecValveModels(doc, section, tbody, meta, deps = {}) {
    const {
        helper,
        escapeHtml = (value) => String(value ?? "")
    } = deps;
    if (!tbody) return;
    if (meta) meta.textContent = section.metaText;

    if (!section.count) {
        renderEmptyRow(tbody, 7, section.emptyMessage, escapeHtml);
        return;
    }

    tbody.innerHTML = "";
    section.rows.forEach((entry) => {
        const tr = doc.createElement("tr");
        tr.className = "ctrl-spec-tr";
        const row = helper.buildControlSpecValveModelRowModel(entry);
        tr.innerHTML = `
            <td class="ctrl-spec-td-mono-bold">${escapeHtml(row.actuatorIdText)}</td>
            <td class="ctrl-spec-td">${escapeHtml(row.actuatorNameText)}</td>
            <td class="ctrl-spec-td-muted">${escapeHtml(row.valveModeText)}</td>
            <td class="ctrl-spec-td-desc-320">${escapeHtml(row.outputsText)}</td>
            <td class="ctrl-spec-td-desc-360">${escapeHtml(row.extendText)}</td>
            <td class="ctrl-spec-td-desc-360">${escapeHtml(row.retractText)}</td>
            <td class="ctrl-spec-td-desc-360">${escapeHtml(`${row.stopText} / 非常停止: ${row.emergencyText}`)}</td>
        `;
        tbody.appendChild(tr);
    });
}

export function renderControlSpecErrorList(doc, section, tbody, meta, deps = {}) {
    const {
        helper,
        escapeHtml = (value) => String(value ?? "")
    } = deps;
    if (!tbody) return;
    if (meta) meta.textContent = section.metaText;

    if (!section.count) {
        renderEmptyRow(tbody, 5, section.emptyMessage, escapeHtml);
        return;
    }

    tbody.innerHTML = "";
    section.errorSteps.forEach((step) => {
        const tr = doc.createElement("tr");
        tr.className = "ctrl-spec-tr";
        const row = helper.buildControlSpecErrorStepRowModel(step);
        tr.innerHTML = `
            <td class="ctrl-spec-td">${escapeHtml(row.typeText)}</td>
            <td class="ctrl-spec-td-mono">${escapeHtml(row.stepNodeText)}</td>
            <td class="ctrl-spec-td-mono-bold">${escapeHtml(row.codeText)}</td>
            <td class="ctrl-spec-td-desc-360">${escapeHtml(row.messageText)}</td>
            <td class="ctrl-spec-td-muted">${escapeHtml(row.targetText)}</td>
        `;
        tbody.appendChild(tr);
    });

    section.timeoutFindings.forEach((finding) => {
        const tr = doc.createElement("tr");
        tr.className = "ctrl-spec-tr";
        const row = helper.buildControlSpecTimeoutFindingRowModel(finding);
        tr.innerHTML = `
            <td class="ctrl-spec-td">${escapeHtml(row.typeText)}</td>
            <td class="ctrl-spec-td-mono">${escapeHtml(row.stepNodeText)}</td>
            <td class="ctrl-spec-td-mono-bold">${escapeHtml(row.codeText)}</td>
            <td class="ctrl-spec-td-desc-360">${escapeHtml(row.messageText)}</td>
            <td class="ctrl-spec-td-muted">${escapeHtml(row.targetText)}</td>
        `;
        tbody.appendChild(tr);
    });
}

export function renderControlSpecConditionSteps(doc, section, tbody, meta, deps = {}) {
    const {
        helper,
        escapeHtml = (value) => String(value ?? ""),
        formatConditionStepExpression = () => "",
        formatConditionBranches = () => ""
    } = deps;
    if (!tbody) return;
    if (meta) meta.textContent = section.metaText;

    if (!section.count) {
        renderEmptyRow(tbody, 6, section.emptyMessage, escapeHtml);
        return;
    }

    tbody.innerHTML = "";
    section.rows.forEach((step) => {
        const tr = doc.createElement("tr");
        tr.className = "ctrl-spec-tr";
        const row = helper.buildControlSpecConditionRowModel(
            step,
            formatConditionStepExpression,
            formatConditionBranches
        );
        tr.innerHTML = `
            <td class="ctrl-spec-td-mono-bold-dark">${escapeHtml(row.stepText)}</td>
            <td class="ctrl-spec-td">${escapeHtml(row.nameText)}</td>
            <td class="ctrl-spec-td-muted">${escapeHtml(row.kindText)}</td>
            <td class="ctrl-spec-td-desc-320">${escapeHtml(row.expressionText)}</td>
            <td class="ctrl-spec-td-desc">${escapeHtml(row.branchesText)}</td>
            <td class="ctrl-spec-td-mono-muted">${escapeHtml(row.timeoutText)}</td>
        `;
        tbody.appendChild(tr);
    });
}

export function renderControlSpecActionSteps(doc, section, tbody, meta, deps = {}) {
    const {
        helper,
        escapeHtml = (value) => String(value ?? ""),
        formatCommands = () => "",
        formatConditions = () => ""
    } = deps;
    if (!tbody) return;
    if (meta) meta.textContent = section.metaText;

    if (!section.count) {
        renderEmptyRow(tbody, 7, section.emptyMessage, escapeHtml);
        return;
    }

    tbody.innerHTML = "";
    section.rows.forEach((step) => {
        const tr = doc.createElement("tr");
        tr.className = "ctrl-spec-tr";
        const row = helper.buildControlSpecActionRowModel(
            step,
            formatCommands,
            formatConditions
        );
        tr.innerHTML = `
            <td class="ctrl-spec-td-mono-bold-dark">${escapeHtml(row.stepText)}</td>
            <td class="ctrl-spec-td">${escapeHtml(row.labelText)}</td>
            <td class="ctrl-spec-td-muted">${escapeHtml(row.actuatorText)}</td>
            <td class="ctrl-spec-td-muted">${escapeHtml(row.actionText)}</td>
            <td class="ctrl-spec-td-desc">${escapeHtml(row.commandsText)}</td>
            <td class="ctrl-spec-td-desc">${escapeHtml(row.doneConditionsText)}</td>
            <td class="ctrl-spec-td-mono-muted">${escapeHtml(row.timeoutText)}</td>
        `;
        tbody.appendChild(tr);
    });
}

export function openControlSpecFindingNode(deps = {}) {
    const {
        nodeId = "",
        findFlowModuleNameForNode = () => "",
        alertMessage = () => {},
        setActiveView = () => {},
        setActiveFlowModule = () => {},
        state,
        renderFlowNodeEditor = () => {},
        requestAnimationFrameFn = (callback) => callback(),
        getNodeElement = () => null,
        setTimeoutFn = (callback) => callback()
    } = deps;
    const moduleName = findFlowModuleNameForNode(nodeId);
    if (!moduleName) {
        alertMessage(`対象ノード '${nodeId}' が見つかりません。`);
        return { ok: false, missing: "node" };
    }
    setActiveView("flow");
    setActiveFlowModule(moduleName);
    if (state) state.selectedFlowNodeId = String(nodeId);
    renderFlowNodeEditor();
    requestAnimationFrameFn(() => {
        const nodeEl = getNodeElement(nodeId);
        nodeEl?.scrollIntoView?.({ block: "center", inline: "center" });
        nodeEl?.classList?.add("flow-connection-source");
        setTimeoutFn(() => nodeEl?.classList?.remove("flow-connection-source"), 1200);
    });
    return { ok: true, moduleName };
}

export function openControlSpecFindingSignal(deps = {}) {
    const {
        signalId = "",
        project,
        alertMessage = () => {},
        setActiveView = () => {},
        setControlSpecTab = () => {},
        loadSignalToForm = () => {}
    } = deps;
    const signals = Array.isArray(project?.signals) ? project.signals : [];
    if (!signals.some((sig) => sig.id === signalId)) {
        alertMessage(`対象信号 '${signalId}' が見つかりません。`);
        return { ok: false, missing: "signal" };
    }
    setActiveView("control-spec");
    setControlSpecTab("signals");
    loadSignalToForm(signalId);
    return { ok: true };
}

export function openControlSpecFindingActuator(deps = {}) {
    const {
        actuatorId = "",
        actionId = "",
        project,
        alertMessage = () => {},
        setActiveView = () => {},
        setControlSpecTab = () => {},
        loadActuatorToForm = () => {},
        loadActionToCard = () => {}
    } = deps;
    const actuators = Array.isArray(project?.actuators) ? project.actuators : [];
    const actuator = actuators.find((act) => act.id === actuatorId);
    if (!actuator) {
        alertMessage(`対象アクチュエータ '${actuatorId}' が見つかりません。`);
        return { ok: false, missing: "actuator" };
    }
    setActiveView("control-spec");
    setControlSpecTab("actuators");
    loadActuatorToForm(actuatorId);
    if (actionId) {
        const index = (Array.isArray(actuator.actions) ? actuator.actions : []).findIndex((action) => action.id === actionId);
        if (index >= 0) loadActionToCard(index);
    }
    return { ok: true };
}

export function openControlSpecFindingTarget(button, deps = {}) {
    const target = button?.dataset?.findingTarget || "";
    if (target === "node") {
        return openControlSpecFindingNode({
            ...deps,
            nodeId: button?.dataset?.nodeId || ""
        });
    }
    if (target === "signal") {
        return openControlSpecFindingSignal({
            ...deps,
            signalId: button?.dataset?.signalId || ""
        });
    }
    if (target === "actuator") {
        return openControlSpecFindingActuator({
            ...deps,
            actuatorId: button?.dataset?.actuatorId || "",
            actionId: button?.dataset?.actionId || ""
        });
    }
    return { ok: false, ignored: true };
}

export function renderSignalCategoryOptions(doc = document, deps = {}) {
    const {
        categories = [],
        selectedId = "",
        helper = defaultSignalHelper,
        escapeHtml = (value) => String(value ?? "")
    } = deps;
    const select = doc.getElementById("selectSignalCategory");
    if (!select) return;
    const state = helper.buildSignalCategoryOptionsState(categories, selectedId, escapeHtml);
    select.innerHTML = state.options;
}

export function renderControlSpecSignalCategories(doc = document, deps = {}) {
    const {
        categories = [],
        helper = defaultSignalHelper,
        escapeHtml = (value) => String(value ?? ""),
        onEdit = () => {},
        onDelete = () => {}
    } = deps;
    const tbody = doc.getElementById("controlSpecSignalCategoriesTableBody");
    if (!tbody) return;
    tbody.innerHTML = "";
    const listState = helper.buildControlSpecSignalCategoryListState(categories);

    if (listState.isEmpty) {
        renderEmptyRow(tbody, 6, listState.emptyMessage, escapeHtml);
        return;
    }

    listState.rows.forEach((category) => {
        const tr = doc.createElement("tr");
        tr.className = "ctrl-spec-tr";
        const row = helper.buildControlSpecSignalCategoryRowModel(category);
        tr.innerHTML = `
            <td class="ctrl-spec-td-bold">${escapeHtml(row.idText)}</td>
            <td class="ctrl-spec-td">${escapeHtml(row.nameText)}</td>
            <td class="ctrl-spec-td-help">${escapeHtml(row.directionText)}</td>
            <td class="ctrl-spec-td-mono-bold-muted">${escapeHtml(row.addressPrefixText)}</td>
            <td class="ctrl-spec-td-help">${escapeHtml(row.startByteText)}</td>
            <td class="ctrl-spec-td-btns">
                <button type="button" class="control-spec-action-btn edit-btn" data-category-id="${escapeHtml(row.idText)}">編集</button>
                <button type="button" class="control-spec-action-btn delete delete-btn" data-category-id="${escapeHtml(row.idText)}">削除</button>
            </td>
        `;
        tr.querySelector(".edit-btn")?.addEventListener("click", () => onEdit(row.idText));
        tr.querySelector(".delete-btn")?.addEventListener("click", () => onDelete(row.idText));
        tbody.appendChild(tr);
    });
}

export function applySignalCategoryFormState(doc = document, deps = {}) {
    const {
        formState,
        showError = () => {}
    } = deps;
    if (!formState) return null;
    const title = doc.getElementById("controlSpecSignalCategoryFormTitle");
    if (title) title.textContent = formState.titleText;

    const inputId = doc.getElementById("inputSignalCategoryId");
    if (inputId) {
        inputId.value = formState.inputId;
        inputId.disabled = formState.inputIdDisabled;
        inputId.style.background = formState.inputIdBackground;
    }

    const inputName = doc.getElementById("inputSignalCategoryName");
    if (inputName) inputName.value = formState.inputName;

    const selectDirection = doc.getElementById("selectSignalCategoryDirection");
    if (selectDirection) selectDirection.value = formState.direction;

    const selectPrefix = doc.getElementById("selectSignalCategoryAddressPrefix");
    if (selectPrefix) selectPrefix.value = formState.addressPrefix;

    const inputStartByte = doc.getElementById("inputSignalCategoryStartByte");
    if (inputStartByte) inputStartByte.value = formState.startByte;

    showError("");
    return formState.editingSignalCategoryId;
}

export function loadSignalCategoryToForm(doc = document, deps = {}) {
    const {
        category,
        helper = defaultSignalHelper,
        showError = () => {}
    } = deps;
    if (!category) return null;
    const formState = helper.buildLoadedSignalCategoryFormState(category);
    return applySignalCategoryFormState(doc, { formState, showError });
}

export function resetSignalCategoryForm(doc = document, deps = {}) {
    const {
        helper = defaultSignalHelper,
        showError = () => {}
    } = deps;
    const formState = helper.buildResetSignalCategoryFormState();
    return applySignalCategoryFormState(doc, { formState, showError });
}

export function saveControlSpecSignalCategory(deps = {}) {
    const {
        project,
        helper = defaultSignalHelper,
        categories = [],
        editingSignalCategoryId = null,
        formValues = {},
        showError = () => {},
        renderSignalCategories = () => {},
        renderSignalCategoryOptions: rerenderSignalCategoryOptions = () => {},
        getSelectedSignalCategoryId = () => "",
        renderSignals = () => {},
        scheduleAutoSave = () => {},
        resetForm = () => {}
    } = deps;
    const formInput = helper.buildControlSpecSignalCategoryFormInput(formValues);
    const draft = helper.buildControlSpecSignalCategoryDraft(formInput);
    const validation = helper.validateControlSpecSignalCategoryDraft(
        draft,
        editingSignalCategoryId,
        categories
    );
    if (!validation.ok) {
        showError(validation.errorMessage);
        return { ok: false, errorMessage: validation.errorMessage };
    }

    project.signalCategories = helper.buildSavedControlSpecSignalCategories(categories, draft, validation);
    renderSignalCategories();
    rerenderSignalCategoryOptions(getSelectedSignalCategoryId());
    renderSignals();
    scheduleAutoSave();
    resetForm();
    return { ok: true };
}

export function deleteControlSpecSignalCategory(deps = {}) {
    const {
        project,
        helper = defaultSignalHelper,
        categoryId,
        categories = [],
        signals = [],
        confirmDelete = () => true,
        alertMessage = () => {},
        renderSignalCategories = () => {},
        renderSignalCategoryOptions: rerenderSignalCategoryOptions = () => {},
        renderSignals = () => {},
        scheduleAutoSave = () => {},
        editingSignalCategoryId = null,
        resetForm = () => {}
    } = deps;
    const deleteState = helper.buildDeleteControlSpecSignalCategoryState(categoryId, categories, signals);
    if (!deleteState.ok) {
        alertMessage(deleteState.alertMessage);
        return { ok: false, alertMessage: deleteState.alertMessage };
    }
    if (!confirmDelete(deleteState.confirmMessage)) {
        return { ok: false, cancelled: true };
    }

    project.signalCategories = deleteState.nextCategories;
    project.signals = deleteState.nextSignals;
    renderSignalCategories();
    rerenderSignalCategoryOptions("");
    renderSignals();
    scheduleAutoSave();
    if (editingSignalCategoryId === categoryId) resetForm();
    return { ok: true };
}

export function renderControlSpecSignals(doc = document, deps = {}) {
    const {
        signals = [],
        helper = defaultSignalHelper,
        findSignalCategory = () => null,
        escapeHtml = (value) => String(value ?? ""),
        onEdit = () => {},
        onDelete = () => {}
    } = deps;
    const tbody = doc.getElementById("controlSpecSignalsTableBody");
    if (!tbody) return;
    tbody.innerHTML = "";
    const listState = helper.buildControlSpecSignalListState(signals);
    const signalsMeta = doc.getElementById("controlSpecSignalsMeta");
    if (signalsMeta) signalsMeta.textContent = listState.metaText;

    if (listState.isEmpty) {
        renderEmptyRow(tbody, 10, listState.emptyMessage, escapeHtml);
        return;
    }

    listState.rows.forEach((sig) => {
        const tr = doc.createElement("tr");
        tr.className = "ctrl-spec-tr";
        const row = helper.buildControlSpecSignalRowModel(sig, findSignalCategory);
        tr.innerHTML = `
            <td class="ctrl-spec-td-bold">${escapeHtml(row.idText)}</td>
            <td class="ctrl-spec-td">${escapeHtml(row.nameText)}</td>
            <td class="ctrl-spec-td-help">${escapeHtml(row.categoryText)}</td>
            <td class="ctrl-spec-td"><span class="control-spec-badge ${row.badgeClass}">${row.directionLabel}</span></td>
            <td class="ctrl-spec-td-mono-bold-muted" title="${escapeHtml(row.iecNameText)}">${escapeHtml(row.addressText)}</td>
            <td class="ctrl-spec-td-help">${escapeHtml(row.dataTypeText)}</td>
            <td class="ctrl-spec-td-help">${escapeHtml(row.activeStateText)}</td>
            <td class="ctrl-spec-td-help">${escapeHtml(row.actuatorIdText)}</td>
            <td class="ctrl-spec-td-truncate-150" title="${escapeHtml(row.descriptionText)}">${escapeHtml(row.descriptionText)}</td>
            <td class="ctrl-spec-td-btns">
                <button type="button" class="control-spec-action-btn edit-btn" data-sig-id="${escapeHtml(row.idText)}">編集</button>
                <button type="button" class="control-spec-action-btn delete delete-btn" data-sig-id="${escapeHtml(row.idText)}">削除</button>
            </td>
        `;
        tr.querySelector(".edit-btn")?.addEventListener("click", () => onEdit(row.idText));
        tr.querySelector(".delete-btn")?.addEventListener("click", () => onDelete(row.idText));
        tbody.appendChild(tr);
    });
}

export function applySignalFormState(doc = document, deps = {}) {
    const {
        formState,
        renderSignalCategoryOptions: rerenderSignalCategoryOptions = () => {},
        applySelectedSignalCategoryDefaults = () => {}
    } = deps;
    if (!formState) return null;
    const title = doc.getElementById("controlSpecSignalFormTitle");
    if (title) title.textContent = formState.titleText;

    const inputId = doc.getElementById("inputSignalId");
    if (inputId) {
        inputId.value = formState.inputId;
        inputId.disabled = formState.inputIdDisabled;
        inputId.style.background = formState.inputIdBackground;
    }

    const inputName = doc.getElementById("inputSignalName");
    if (inputName) inputName.value = formState.inputName;

    const inputIecName = doc.getElementById("inputSignalIecName");
    if (inputIecName) inputIecName.value = formState.inputIecName;

    rerenderSignalCategoryOptions(formState.category);
    if (formState.editingSignalId == null) {
        applySelectedSignalCategoryDefaults();
    }

    const selectDirection = doc.getElementById("selectSignalDirection");
    if (selectDirection) {
        if (formState.editingSignalId == null && selectDirection.value) {
            // keep selected default written by applySelectedSignalCategoryDefaults
        } else {
            selectDirection.value = formState.direction;
        }
    }

    const inputAddress = doc.getElementById("inputSignalAddress");
    if (inputAddress) inputAddress.value = formState.address;

    const selectDataType = doc.getElementById("selectSignalDataType");
    if (selectDataType) selectDataType.value = formState.dataType;

    const selectActive = doc.getElementById("selectSignalActiveState");
    if (selectActive) selectActive.value = formState.activeState;

    const inputActuatorId = doc.getElementById("inputSignalActuatorId");
    if (inputActuatorId) inputActuatorId.value = formState.actuatorId;

    const textareaDesc = doc.getElementById("textareaSignalDesc");
    if (textareaDesc) textareaDesc.value = formState.description;

    const errBox = doc.getElementById("controlSpecSignalFormError");
    if (errBox && formState.hideError) errBox.style.display = "none";
    return formState.editingSignalId;
}

export function loadSignalToForm(doc = document, deps = {}) {
    const {
        signal,
        signalId,
        helper = defaultSignalHelper,
        renderSignalCategoryOptions: rerenderSignalCategoryOptions = () => {}
    } = deps;
    if (!signal) return null;
    const formState = helper.buildLoadedControlSpecSignalFormState(signal, signalId);
    return applySignalFormState(doc, { formState, renderSignalCategoryOptions: rerenderSignalCategoryOptions });
}

export function resetSignalForm(doc = document, deps = {}) {
    const {
        helper = defaultSignalHelper,
        defaultCategoryId = "",
        renderSignalCategoryOptions: rerenderSignalCategoryOptions = () => {},
        applySelectedSignalCategoryDefaults = () => {}
    } = deps;
    const formState = helper.buildResetControlSpecSignalFormState(defaultCategoryId);
    return applySignalFormState(doc, {
        formState,
        renderSignalCategoryOptions: rerenderSignalCategoryOptions,
        applySelectedSignalCategoryDefaults
    });
}

export function saveControlSpecSignal(deps = {}) {
    const {
        project,
        helper = defaultSignalHelper,
        editingSignalId = null,
        formValues = {},
        showError = () => {},
        recomputeAll = () => {},
        renderSignals = () => {},
        renderView = () => {},
        scheduleAutoSave = () => {},
        resetForm = () => {}
    } = deps;
    if (!Array.isArray(project.signals)) {
        project.signals = [];
    }
    const formInput = helper.buildControlSpecSignalFormInput(formValues);
    const draft = helper.buildControlSpecSignalDraft(formInput);
    const validation = helper.validateControlSpecSignalDraft(draft, editingSignalId, project.signals);
    if (!validation.ok) {
        showError(validation.errorMessage);
        return { ok: false, errorMessage: validation.errorMessage };
    }

    project.signals = helper.buildSavedControlSpecSignals(project.signals, draft, validation);
    recomputeAll();
    renderSignals();
    renderView();
    scheduleAutoSave();
    resetForm();
    return { ok: true };
}

export function deleteControlSpecSignal(deps = {}) {
    const {
        project,
        helper = defaultSignalHelper,
        signalId,
        actuators = [],
        confirmDelete = () => true,
        editingSignalId = null,
        resetForm = () => {},
        recomputeAll = () => {},
        renderSignals = () => {},
        renderView = () => {},
        scheduleAutoSave = () => {}
    } = deps;
    if (!Array.isArray(project?.signals)) {
        return { ok: false, missingSignals: true };
    }

    const refCheck = helper.findControlSpecSignalReferenceInActuators(signalId, actuators);
    const deleteState = helper.buildDeleteControlSpecSignalState(signalId, refCheck, project.signals);
    if (!confirmDelete(deleteState.confirmMessage)) {
        return { ok: false, cancelled: true };
    }

    project.signals = deleteState.nextSignals;
    if (editingSignalId === signalId) {
        resetForm();
    }
    recomputeAll();
    renderSignals();
    renderView();
    scheduleAutoSave();
    return { ok: true };
}

export function renderControlSpecFlowSignalCandidates(doc = document, deps = {}) {
    const {
        candidates = [],
        helper = defaultSignalHelper,
        escapeHtml = (value) => String(value ?? "")
    } = deps;
    const select = doc.getElementById("selectControlSpecFlowSignalCandidate");
    if (!select) return { candidates };
    const optionsState = helper.buildControlSpecFlowSignalCandidateOptionsState(candidates, escapeHtml);
    select.innerHTML = optionsState.options;
    return { candidates };
}

export function applyControlSpecFlowSignalCandidate(doc = document, deps = {}) {
    const {
        candidates = [],
        helper = defaultSignalHelper,
        selectedIndex = "",
        findSignalCategory = () => null,
        loadSignalToForm = () => {},
        resetSignalForm = () => {}
    } = deps;
    if (selectedIndex === "") return null;
    const candidate = candidates[Number(selectedIndex)];
    if (!candidate) return null;

    const applyState = helper.buildControlSpecFlowSignalCandidateApplyState(
        candidate,
        (categoryId) => Boolean(findSignalCategory(categoryId))
    );
    if (applyState.mode === "existing") {
        loadSignalToForm(applyState.existingSignalId);
        return { mode: "existing", existingSignalId: applyState.existingSignalId };
    }

    resetSignalForm();
    const inputId = doc.getElementById("inputSignalId");
    const inputName = doc.getElementById("inputSignalName");
    const selectCategory = doc.getElementById("selectSignalCategory");
    const selectDirection = doc.getElementById("selectSignalDirection");
    const textareaDesc = doc.getElementById("textareaSignalDesc");
    const inputActuatorId = doc.getElementById("inputSignalActuatorId");
    const formState = applyState.formState;
    if (inputId) inputId.value = formState.signalId;
    if (inputName) inputName.value = formState.signalName;
    if (selectCategory && formState.categoryId) selectCategory.value = formState.categoryId;
    if (selectDirection) selectDirection.value = formState.direction;
    if (textareaDesc) textareaDesc.value = formState.description;
    if (inputActuatorId) inputActuatorId.value = formState.actuatorId;
    return { mode: "new", formState };
}

export function renderControlSpecActuators(doc = document, deps = {}) {
    const {
        actuators = [],
        helper = defaultActuatorHelper,
        escapeHtml = (value) => String(value ?? ""),
        getActuatorTypeLabel = () => "",
        getMotorControlTypeLabel = () => "",
        getPneumaticValveModeLabel = () => "",
        normalizeActuatorControlMethod = (value) => value,
        normalizeAxisActuatorType = (value) => value,
        onEdit = () => {},
        onDelete = () => {},
        renderActuatorTypeCatalogEditor = () => {}
    } = deps;
    const tbody = doc.getElementById("controlSpecActuatorsTableBody");
    if (!tbody) return;

    tbody.innerHTML = "";
    const listState = helper.buildControlSpecActuatorListState(actuators);
    const actuatorsMeta = doc.getElementById("controlSpecActuatorsMeta");
    if (actuatorsMeta) actuatorsMeta.textContent = listState.metaText;

    if (listState.isEmpty) {
        renderEmptyRow(tbody, 7, listState.emptyMessage, escapeHtml);
        renderActuatorTypeCatalogEditor();
        return;
    }

    listState.rows.forEach((act) => {
        const tr = doc.createElement("tr");
        tr.className = "ctrl-spec-tr";
        const row = helper.buildControlSpecActuatorRowModel(
            act,
            getActuatorTypeLabel,
            getMotorControlTypeLabel,
            getPneumaticValveModeLabel,
            normalizeActuatorControlMethod,
            normalizeAxisActuatorType
        );
        tr.innerHTML = `
            <td class="ctrl-spec-td-bold">${escapeHtml(row.idText)}</td>
            <td class="ctrl-spec-td">${escapeHtml(row.nameText)}</td>
            <td class="ctrl-spec-td-muted">${escapeHtml(row.typeText)}</td>
            <td class="ctrl-spec-td-help">${escapeHtml(row.controlMethodText)}</td>
            <td class="ctrl-spec-td-help">${escapeHtml(row.valveSummaryText || "-")}</td>
            <td class="ctrl-spec-td-bold-help">${escapeHtml(row.actionCountText)}</td>
            <td class="ctrl-spec-td-btns">
                <button type="button" class="control-spec-action-btn edit-btn" data-act-id="${escapeHtml(row.idText)}">編集</button>
                <button type="button" class="control-spec-action-btn delete delete-btn" data-act-id="${escapeHtml(row.idText)}">削除</button>
            </td>
        `;
        tr.querySelector(".edit-btn")?.addEventListener("click", () => onEdit(row.idText));
        tr.querySelector(".delete-btn")?.addEventListener("click", () => onDelete(row.idText));
        tbody.appendChild(tr);
    });

    renderActuatorTypeCatalogEditor();
}

export function applyActuatorFormState(doc = document, deps = {}) {
    const {
        formState,
        buildActuatorTypeOptions = () => "",
        normalizeAxisActuatorType = (value) => value,
        normalizeMotorControlType = (value) => value,
        normalizeActuatorControlMethod = (value) => value,
        syncMotorControlTypeField = () => {},
        syncPneumaticValveModeField = () => {},
        syncActuatorValveModelFields = () => {},
        syncActuatorControlMethodDefault = () => {},
        populateActionSignalOptions = () => {}
    } = deps;
    if (!formState) return null;

    const title = doc.getElementById("controlSpecActuatorFormTitle");
    if (title) title.textContent = formState.titleText;

    const inputId = doc.getElementById("inputActuatorId");
    if (inputId) {
        inputId.value = formState.inputId;
        inputId.disabled = formState.inputIdDisabled;
        inputId.style.background = formState.inputIdBackground;
    }

    const inputName = doc.getElementById("inputActuatorName");
    if (inputName) inputName.value = formState.inputName;

    const selectType = doc.getElementById("selectActuatorType");
    if (selectType) {
        selectType.innerHTML = buildActuatorTypeOptions(formState.actuatorType);
        selectType.value = normalizeAxisActuatorType(formState.actuatorType);
    }

    const selectMotorType = doc.getElementById("selectActuatorMotorControlType");
    if (selectMotorType) {
        selectMotorType.value = normalizeMotorControlType(formState.motorControlType, formState.actuatorType);
    }

    const selectValveMode = doc.getElementById("selectActuatorPneumaticValveMode");
    if (selectValveMode) {
        selectValveMode.value = formState.pneumaticValveMode || "doubleSolenoid";
    }

    const selectControlMethod = doc.getElementById("selectActuatorControlMethod");
    if (selectControlMethod) {
        selectControlMethod.value = normalizeActuatorControlMethod(formState.controlMethod, formState.actuatorType);
    }

    const inputAxisRef = doc.getElementById("inputActuatorAxisRef");
    if (inputAxisRef) inputAxisRef.value = formState.axisRef;
    applyActuatorValveModelFormState(doc, formState.valveModel);

    syncMotorControlTypeField("selectActuatorType", "selectActuatorMotorControlType");
    syncPneumaticValveModeField("selectActuatorType", "selectActuatorPneumaticValveMode");
    syncActuatorValveModelFields();
    syncActuatorControlMethodDefault(false);

    const errBox = doc.getElementById("controlSpecActuatorFormError");
    if (errBox && formState.hideError) errBox.style.display = "none";

    populateActionSignalOptions();

    const detailCard = doc.getElementById("controlSpecActionDetailCard");
    if (detailCard && formState.hideDetailCard) detailCard.style.display = "none";

    return {
        editingActuatorId: formState.editingActuatorId,
        actuatorActions: formState.actuatorActions,
        selectedActionIndex: formState.selectedActionIndex
    };
}

export function loadActuatorToForm(doc = document, deps = {}) {
    const { actuator, actuatorId, helper = defaultActuatorHelper } = deps;
    if (!actuator) return null;
    const formState = helper.buildLoadedControlSpecActuatorFormState(actuator, actuatorId);
    return applyActuatorFormState(doc, { ...deps, formState });
}

export function resetActuatorForm(doc = document, deps = {}) {
    const { helper = defaultActuatorHelper, defaultActions = [] } = deps;
    const formState = helper.buildResetControlSpecActuatorFormState(defaultActions);
    return applyActuatorFormState(doc, { ...deps, formState });
}

export function populateActionSignalOptions(doc = document, deps = {}) {
    const {
        signals = [],
        helper = defaultActuatorHelper,
        escapeHtml = (value) => String(value ?? "")
    } = deps;
    const setOutputSelect = doc.getElementById("selectActionSetOutput");
    const resetOutputSelect = doc.getElementById("selectActionResetOutput");
    const doneSignalSelect = doc.getElementById("selectActionDoneSignal");
    const faultSignalSelect = doc.getElementById("selectActionFaultSignal");
    if (!setOutputSelect || !resetOutputSelect || !doneSignalSelect || !faultSignalSelect) return;

    const optionsState = helper.buildControlSpecActionSignalOptionsState(signals, escapeHtml);
    setOutputSelect.innerHTML = optionsState.setOutputOptions;
    resetOutputSelect.innerHTML = optionsState.resetOutputOptions;
    doneSignalSelect.innerHTML = optionsState.doneSignalOptions;
    faultSignalSelect.innerHTML = optionsState.faultSignalOptions;
}

export function renderControlSpecActionList(doc = document, deps = {}) {
    const {
        actuatorActions = [],
        selectedActionIndex = null,
        helper = defaultActuatorHelper,
        escapeHtml = (value) => String(value ?? ""),
        onEdit = () => {},
        onDelete = () => {}
    } = deps;
    const listContainer = doc.getElementById("controlSpecActionList");
    if (!listContainer) return;

    listContainer.innerHTML = "";
    const listState = helper.buildControlSpecActionListState(actuatorActions);
    if (listState.isEmpty) {
        listContainer.innerHTML = `
            <div style="text-align: center; color: #888; font-size: 0.85em; padding: 10px; border: 1px dashed #ddd; border-radius: 4px; background: #fafafa;">
                ${escapeHtml(listState.emptyMessage)}
            </div>
        `;
        return;
    }

    listState.rows.forEach((action, index) => {
        const row = helper.buildControlSpecActionListRowModel(action, index, selectedActionIndex);
        const div = doc.createElement("div");
        div.className = `control-spec-action-item ${row.isActive ? "is-active" : ""}`;
        div.innerHTML = `
            <div class="ctrl-action-header">
                <span class="ctrl-action-title">${escapeHtml(row.idText)} (${escapeHtml(row.nameText)})</span>
                <div class="ctrl-action-btns">
                    <button type="button" class="control-spec-action-btn ctrl-action-btn-sm edit-action-btn" data-idx="${index}">編集</button>
                    <button type="button" class="control-spec-action-btn delete ctrl-action-btn-sm delete-action-btn" data-idx="${index}">削除</button>
                </div>
            </div>
            <div class="control-spec-action-meta ctrl-action-meta">
                <span>出力: <strong class="text-blue">${escapeHtml(row.setOutputText)}</strong></span>
                <span>リセット: <strong class="text-blue">${escapeHtml(row.resetOutputText)}</strong></span>
                <span>完了方式: <strong>${escapeHtml(row.completionModeText)}</strong></span>
                <span>完了条件: <strong class="text-green">${escapeHtml(row.doneConditionText)}</strong></span>
                <span>異常条件: <strong class="text-danger">${escapeHtml(row.faultConditionText)}</strong></span>
                <span>タイムアウト: <strong>${escapeHtml(row.timeoutText)}</strong></span>
                ${row.plcopenText ? `<span>FB: <strong class="text-purple">${escapeHtml(row.plcopenText)}</strong></span>` : ""}
            </div>
        `;
        div.querySelector(".edit-action-btn")?.addEventListener("click", (event) => {
            event.stopPropagation();
            onEdit(index);
        });
        div.querySelector(".delete-action-btn")?.addEventListener("click", (event) => {
            event.stopPropagation();
            onDelete(index);
        });
        div.addEventListener("click", () => onEdit(index));
        listContainer.appendChild(div);
    });
}

export function syncActionCompletionModeFields(doc = document, deps = {}) {
    const { helper = defaultActuatorHelper } = deps;
    const resolvedHelper = typeof helper?.buildControlSpecActionCompletionModeFieldState === "function"
        ? helper
        : defaultActuatorHelper;
    const selectCompletionMode = doc.getElementById("selectActionCompletionMode");
    const inputTimeout = doc.getElementById("inputActionTimeoutSec");
    const selectDoneSig = doc.getElementById("selectActionDoneSignal");
    const selectDoneVal = doc.getElementById("selectActionDoneValue");
    if (!selectCompletionMode || !inputTimeout || !selectDoneSig || !selectDoneVal) return null;

    const fieldState = resolvedHelper.buildControlSpecActionCompletionModeFieldState(
        selectCompletionMode.value,
        inputTimeout.value
    );

    selectCompletionMode.value = fieldState.completionMode;
    inputTimeout.disabled = fieldState.timeoutDisabled;
    inputTimeout.style.background = fieldState.timeoutDisabled ? "#f3f4f6" : "#fff";
    inputTimeout.value = String(fieldState.timeoutValue ?? inputTimeout.value ?? "");
    selectDoneSig.disabled = fieldState.doneSignalDisabled;
    selectDoneSig.style.background = fieldState.doneSignalDisabled ? "#f3f4f6" : "#fff";
    selectDoneVal.disabled = fieldState.doneValueDisabled;
    selectDoneVal.style.background = fieldState.doneValueDisabled ? "#f3f4f6" : "#fff";
    return fieldState;
}

export function applyActionDetailFormState(doc = document, deps = {}) {
    const { detailState } = deps;
    if (!detailState) return null;

    const title = doc.getElementById("controlSpecActionDetailTitle");
    if (title) title.textContent = detailState.titleText;

    const inputId = doc.getElementById("inputActionId");
    if (inputId) {
        inputId.value = detailState.inputId;
        inputId.disabled = detailState.inputIdDisabled;
        inputId.style.background = detailState.inputIdBackground;
    }

    const inputName = doc.getElementById("inputActionName");
    if (inputName) inputName.value = detailState.inputName;

    const selectCompletionMode = doc.getElementById("selectActionCompletionMode");
    if (selectCompletionMode) selectCompletionMode.value = detailState.completionMode;

    const inputTimeout = doc.getElementById("inputActionTimeoutSec");
    if (inputTimeout) inputTimeout.value = detailState.timeoutSec;

    const selectPlcopenFamily = doc.getElementById("selectActionPlcopenFamily");
    if (selectPlcopenFamily) selectPlcopenFamily.value = detailState.plcopenFamily;

    const inputPlcopenFbName = doc.getElementById("inputActionPlcopenFbName");
    if (inputPlcopenFbName) inputPlcopenFbName.value = detailState.plcopenFbName;

    const inputExecuteSignal = doc.getElementById("inputActionExecuteSignal");
    if (inputExecuteSignal) inputExecuteSignal.value = detailState.executeSignal;

    const inputDoneStatusSignal = doc.getElementById("inputActionDoneStatusSignal");
    if (inputDoneStatusSignal) inputDoneStatusSignal.value = detailState.doneStatusSignal;

    const inputBusySignal = doc.getElementById("inputActionBusySignal");
    if (inputBusySignal) inputBusySignal.value = detailState.busySignal;

    const inputErrorSignal = doc.getElementById("inputActionErrorSignal");
    if (inputErrorSignal) inputErrorSignal.value = detailState.errorSignal;

    const inputErrorIdSignal = doc.getElementById("inputActionErrorIdSignal");
    if (inputErrorIdSignal) inputErrorIdSignal.value = detailState.errorIdSignal;

    const inputPositionParam = doc.getElementById("inputActionPositionParam");
    if (inputPositionParam) inputPositionParam.value = detailState.positionParam;

    const inputVelocityParam = doc.getElementById("inputActionVelocityParam");
    if (inputVelocityParam) inputVelocityParam.value = detailState.velocityParam;

    const selectSetOutput = doc.getElementById("selectActionSetOutput");
    if (selectSetOutput) selectSetOutput.value = detailState.setOutput;

    const selectResetOutput = doc.getElementById("selectActionResetOutput");
    if (selectResetOutput) selectResetOutput.value = detailState.resetOutput;

    const selectDoneSig = doc.getElementById("selectActionDoneSignal");
    const selectDoneVal = doc.getElementById("selectActionDoneValue");
    if (selectDoneSig && selectDoneVal) {
        selectDoneSig.value = detailState.doneSignal;
        selectDoneVal.value = detailState.doneValue;
    }

    const selectFaultSig = doc.getElementById("selectActionFaultSignal");
    const selectFaultVal = doc.getElementById("selectActionFaultValue");
    if (selectFaultSig && selectFaultVal) {
        selectFaultSig.value = detailState.faultSignal;
        selectFaultVal.value = detailState.faultValue;
    }

    syncActionCompletionModeFields(doc, deps);

    const detailCard = doc.getElementById("controlSpecActionDetailCard");
    if (detailCard && detailState.showDetailCard) detailCard.style.display = "flex";
    return detailState.selectedActionIndex;
}

export function loadActionToCard(doc = document, deps = {}) {
    const { action, index, helper = defaultActuatorHelper } = deps;
    if (!action) return null;
    const detailState = helper.buildLoadedControlSpecActionDetailState(action, index);
    return applyActionDetailFormState(doc, { ...deps, detailState });
}

export function deleteActionFromList(doc = document, deps = {}) {
    const {
        index,
        action,
        helper = defaultActuatorHelper,
        selectedActionIndex = null,
        editingActuatorId = "",
        actuatorActions = [],
        findReference = () => ({ referenced: false }),
        confirmDelete = () => true
    } = deps;
    if (!action) return null;

    const check = editingActuatorId ? findReference(editingActuatorId, action.id) : { referenced: false };
    const deleteState = helper.buildDeleteControlSpecActionState(
        index,
        action,
        selectedActionIndex,
        editingActuatorId,
        check,
        actuatorActions
    );
    if (!confirmDelete(deleteState.confirmMessage)) {
        return { ok: false, cancelled: true };
    }

    const detailCard = doc.getElementById("controlSpecActionDetailCard");
    if (detailCard && deleteState.hideDetailCard) detailCard.style.display = "none";
    return {
        ok: true,
        actuatorActions: deleteState.nextActions,
        selectedActionIndex: deleteState.nextSelectedActionIndex
    };
}

export function saveActionDetail(doc = document, deps = {}) {
    const {
        helper = defaultActuatorHelper,
        selectedActionIndex = null,
        actuatorActions = [],
        normalizePlcopenActionMeta = (value) => value,
        normalizeActionParameters = (value) => value,
        normalizeActionStatus = (value) => value,
        alertMessage = () => {}
    } = deps;
    if (selectedActionIndex === null) return null;

    const inputName = doc.getElementById("inputActionName");
    const inputTimeout = doc.getElementById("inputActionTimeoutSec");
    const selectPlcopenFamily = doc.getElementById("selectActionPlcopenFamily");
    const inputPlcopenFbName = doc.getElementById("inputActionPlcopenFbName");
    const inputExecuteSignal = doc.getElementById("inputActionExecuteSignal");
    const inputDoneStatusSignal = doc.getElementById("inputActionDoneStatusSignal");
    const inputBusySignal = doc.getElementById("inputActionBusySignal");
    const inputErrorSignal = doc.getElementById("inputActionErrorSignal");
    const inputErrorIdSignal = doc.getElementById("inputActionErrorIdSignal");
    const inputPositionParam = doc.getElementById("inputActionPositionParam");
    const inputVelocityParam = doc.getElementById("inputActionVelocityParam");
    const selectSetOutput = doc.getElementById("selectActionSetOutput");
    const selectResetOutput = doc.getElementById("selectActionResetOutput");
    const selectCompletionMode = doc.getElementById("selectActionCompletionMode");
    const selectDoneSig = doc.getElementById("selectActionDoneSignal");
    const selectDoneVal = doc.getElementById("selectActionDoneValue");
    const selectFaultSig = doc.getElementById("selectActionFaultSignal");
    const selectFaultVal = doc.getElementById("selectActionFaultValue");

    if (!inputName || !inputTimeout || !selectSetOutput || !selectResetOutput || !selectCompletionMode || !selectDoneSig || !selectDoneVal || !selectFaultSig || !selectFaultVal) {
        return null;
    }

    const formInput = helper.buildControlSpecActionDetailFormInput({
        name: inputName.value,
        completionMode: selectCompletionMode.value,
        timeoutSec: inputTimeout.value,
        plcopen: normalizePlcopenActionMeta({
            family: selectPlcopenFamily?.value || "",
            fbName: inputPlcopenFbName?.value || ""
        }),
        executeSignal: inputExecuteSignal?.value || "",
        setOutputSig: selectSetOutput.value,
        resetOutputSig: selectResetOutput.value,
        parameters: normalizeActionParameters({
            position: inputPositionParam?.value || "",
            velocity: inputVelocityParam?.value || ""
        }),
        status: normalizeActionStatus({
            busySignal: inputBusySignal?.value || "",
            doneSignal: inputDoneStatusSignal?.value || "",
            errorSignal: inputErrorSignal?.value || "",
            errorIdSignal: inputErrorIdSignal?.value || ""
        }),
        doneSig: selectDoneSig.value,
        doneVal: selectDoneVal.value === "TRUE",
        faultSig: selectFaultSig.value,
        faultVal: selectFaultVal.value === "TRUE"
    });
    const draft = helper.buildControlSpecActionDetailDraft(formInput);
    const validation = helper.validateControlSpecActionDetailDraft(draft);
    if (!validation.ok) {
        alertMessage(validation.errorMessage);
        return { ok: false, errorMessage: validation.errorMessage };
    }

    const nextState = helper.buildSavedControlSpecActionDetailState(actuatorActions, selectedActionIndex, draft);
    const detailCard = doc.getElementById("controlSpecActionDetailCard");
    if (detailCard && nextState.hideDetailCard) detailCard.style.display = "none";
    return {
        ok: true,
        actuatorActions: nextState.actions,
        selectedActionIndex: nextState.selectedActionIndex
    };
}

export function resetActuatorActionsForTypeChange(doc = document, deps = {}) {
    const {
        helper = defaultActuatorHelper,
        editingActuatorId = null,
        actuatorType = "pneumaticCylinder",
        motorControlType = "",
        controlMethod = "",
        mergeActuatorActionsWithDefaults = () => []
    } = deps;
    if (editingActuatorId !== null) return null;

    const nextState = helper.buildResetControlSpecActuatorActionState(
        mergeActuatorActionsWithDefaults([], actuatorType, "", "", motorControlType, controlMethod)
    );
    const detailCard = doc.getElementById("controlSpecActionDetailCard");
    if (detailCard && nextState.hideDetailCard) detailCard.style.display = "none";
    return nextState;
}

export function resetActuatorActionsForMotorControlTypeChange(doc = document, deps = {}) {
    const {
        helper = defaultActuatorHelper,
        editingActuatorId = null,
        actuatorType = "pneumaticCylinder",
        motorControlType = "",
        controlMethod = "",
        mergeActuatorActionsWithDefaults = () => []
    } = deps;
    if (editingActuatorId !== null) return null;

    const nextState = helper.buildResetControlSpecActuatorActionState(
        mergeActuatorActionsWithDefaults([], actuatorType, "", "", motorControlType, controlMethod)
    );
    const detailCard = doc.getElementById("controlSpecActionDetailCard");
    if (detailCard && nextState.hideDetailCard) detailCard.style.display = "none";
    return nextState;
}

export function addControlSpecAction(deps = {}) {
    const {
        helper = defaultActuatorHelper,
        actuatorActions = [],
        createEmptyActuatorAction = () => ({}),
        getNextActionPresetName = () => "カスタム"
    } = deps;
    return helper.buildAddedControlSpecActionState(
        actuatorActions,
        createEmptyActuatorAction(getNextActionPresetName())
    );
}

export function saveControlSpecActuator(deps = {}) {
    const {
        project,
        helper = defaultActuatorHelper,
        editingActuatorId = null,
        formValues = {},
        fallbackId = "",
        showError = () => {},
        clearError = () => {},
        recomputeAll = () => {},
        renderActuators = () => {},
        renderView = () => {},
        refreshFlowNodes = () => {},
        scheduleAutoSave = () => {},
        loadForm = () => {},
        keepEditing = false,
        silentValidation = false,
        resetForm = () => {}
    } = deps;
    if (!Array.isArray(project.actuators)) {
        project.actuators = [];
    }

    const formInput = helper.buildControlSpecActuatorFormInput(
        formValues,
        fallbackId,
        project.actuators,
        editingActuatorId
    );
    const draft = helper.buildControlSpecActuatorDraft(formInput, fallbackId);
    const validation = helper.validateControlSpecActuatorDraft(
        draft,
        editingActuatorId,
        project.actuators
    );
    if (!validation.ok) {
        if (!silentValidation) showError(validation.errorMessage);
        return { ok: false, errorMessage: validation.errorMessage };
    }

    project.actuators = helper.buildSavedControlSpecActuators(project.actuators, draft, validation);
    recomputeAll();
    renderActuators();
    renderView();
    refreshFlowNodes();
    scheduleAutoSave();
    clearError();
    if (keepEditing) {
        loadForm(draft.id);
    } else {
        resetForm();
    }
    return { ok: true, savedActuatorId: draft.id };
}

export function deleteControlSpecActuator(deps = {}) {
    const {
        project,
        helper = defaultActuatorHelper,
        actuatorId,
        findReference = () => ({ referenced: false }),
        confirmDelete = () => true,
        editingActuatorId = null,
        resetForm = () => {},
        recomputeAll = () => {},
        renderActuators = () => {},
        renderView = () => {},
        scheduleAutoSave = () => {}
    } = deps;
    if (!Array.isArray(project?.actuators)) return null;

    const deleteState = helper.buildDeleteControlSpecActuatorState(
        actuatorId,
        findReference(actuatorId, null),
        project.actuators
    );
    if (!confirmDelete(deleteState.confirmMessage)) {
        return { ok: false, cancelled: true };
    }

    project.actuators = deleteState.nextActuators;
    if (editingActuatorId === actuatorId) resetForm();
    recomputeAll();
    renderActuators();
    renderView();
    scheduleAutoSave();
    return { ok: true };
}
